const meetingRouter = [
  {
    path: '/m',
    name: 'MeetingIndex',
    meta: {
      keepAlive: true
    },
    component: () => import('@/views/meeting/index')
  },
  {
    path: '/m/:id(\\d+)',
    name: 'MeetingDetail',
    component: () => import('@/views/meeting/detail')
  },
  {
    path: '/m/sign/:id(\\d+)',
    name: 'MeetingSign',
    component: () => import('@/views/meeting/sign')
  },
  {
    path: '/m/sign/record/:id(\\d+)',
    name: 'MeetingSignRecord',
    component: () => import('@/views/meeting/record')
  },
  {
    path: '/m/apply',
    name: 'MeetingApply',
    component: () => import('@/views/meeting/apply/index')
  },
  {
    path: '/m/apply/success',
    name: 'MeetingApplySuccess',
    component: () => import('@/views/meeting/apply/success')
  },
  {
    path: '/m/seat',
    name: 'MeetingSeat',
    component: () => import('@/views/meeting/seat')
  }
]

export default meetingRouter



// WEBPACK FOOTER //
// ./src/router/modules/meeting.js